import { findAll, register, prefixUtil } from '../../../../Javascript/Sysmex/Utils'

const prefixString = 'sysmexMoleculeCascadingCheckboxes'
const classPrefix = prefixUtil(`.${prefixString}`)

const CascadingCheckboxes = el => {
  const parents = findAll(classPrefix('parent'), el)

  parents.forEach(parent => {
    const checkboxesAll = parent.querySelectorAll('input[type="checkbox"]')
    checkboxesAll.forEach(checkbox => {
      const childrenContainer = el.querySelector(`[data-parent='${checkbox.value}']`)
      // initial show/hide of children
      childrenContainer.style.display = (checkbox.checked) ? 'block' : 'none'
      checkbox.addEventListener('click', (event) => {
        // toggle visibility of children on click of parent
        childrenContainer.style.display = (checkbox.checked) ? 'block' : 'none'
      })
    })
  })
}

register('CascadingCheckboxes', CascadingCheckboxes)
